/**** cat.CapacityType */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'cat',
  table: 'CapacityType',
  title: 'Типы вместимости ТС',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'code',
      title: 'Код',
      type: 'text',
      required: true,
    },
    {
      name: 'title',
      title: 'Название',
      type: 'text',
      required: true,
    },
    {
      name: 'seats',
      title: 'Количество посадочных мест',
      type: 'number',
      required: true,
    },
  ],
  newTemplate: {
    id: null,
    code: '',
    title: ''
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'capacity_id',
        field: 'id',
      },{
        title: 'capacity_long_name',
        field: 'title',
      },
      {
        title: 'capacity_short_name',
        field: 'code',
      },
      {
        title: 'seats',
        field: 'seats',
      }
    ],
    example: `1;Большой вместимости;БВ;200`,
  },
  export: {
    fields: [
      {
        name: 'code',
        title: 'Код',
      },
      {
        name: 'title',
        title: 'Название',
      },
      {
        name: 'seats',
        title: 'Количество посадочных мест',
      },
    ],
  },
};

export default config;
